// @ts-ignore
Array.prototype.toObject = function (key, convert = (o) => o) {
  return this.reduce((p, c) => {
    p[c[key]] = convert(c);
    return p;
  }, {});
};
